export default __webpack_public_path__ + "static/media/Barrier of Thorns.0eaed211.png";